import React from 'react'
import FeatureTourIntroCard from 'pages/shared/FeatureTourModal/FeatureTourIntroCard'
import FeatureTourCarousel from 'pages/shared/FeatureTourModal/FeatureTourCarousel'

import Modal from 'components/Modal'
import { SiteMessageDetail } from 'types/SiteMessageDetail'

type Props = {
  open: boolean
  displayCarousel: boolean
  title: string
  message: string
  siteMessages: Array<SiteMessageDetail>
  skipCallback: () => void
  nextCallback: () => void
  finishCallback: () => void
  closeCallback: ()=> void
}

const FeatureTourModal = ({ open, displayCarousel, title, message, siteMessages, skipCallback, finishCallback, closeCallback, nextCallback }: Props) => {
  return (
    <Modal variant="md" isDisplayed={open} closeCallback={closeCallback}>
      { open && displayCarousel
        ? <FeatureTourCarousel
            title={title}
            siteMessages={siteMessages}
            finishCallback={finishCallback}
          />
        : <FeatureTourIntroCard
            title={title}
            message={message}
            siteMessages={siteMessages}
            skipCallback={skipCallback}
            nextCallback={nextCallback}
          />
        }
    </Modal>
  )
}

export default FeatureTourModal
